var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sms-input" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "a-select",
              {
                attrs: { defaultValue: null },
                model: {
                  value: _vm.channelId,
                  callback: function ($$v) {
                    _vm.channelId = $$v
                  },
                  expression: "channelId",
                },
              },
              [
                _c(
                  "a-select-option",
                  { attrs: { selected: true, value: "null" } },
                  [_vm._v("👉Select SMS Provider...")]
                ),
                _vm._v(" "),
                _vm._l(_vm.smsChannels, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel._id, attrs: { value: channel._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(channel.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("perm_phone_msg"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "middle" },
          [
            _c(
              "a-select",
              {
                attrs: { defaultValue: null },
                model: {
                  value: _vm.senderId,
                  callback: function ($$v) {
                    _vm.senderId = $$v
                  },
                  expression: "senderId",
                },
              },
              [
                _vm._l(_vm.senders, function (sender) {
                  return _c(
                    "a-select-option",
                    { key: sender.uuid, attrs: { value: sender.title } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(sender.title) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "" } }, [
                  _vm._v(
                    "\n                    📞Select Sender\n                "
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons" }, [_vm._v("badge")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticClass: "phone-number-input" },
            [
              _c("vue-country-code", {
                staticClass: "col-3 country-code",
                attrs: { enabledCountryCode: true, defaultCountry: "TR" },
                on: {
                  onSelect: function ($event) {
                    return _vm.onSelect($event)
                  },
                },
              }),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "############",
                    expression: "'############'",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("message.phone"),
                  autocomplete: "off",
                  trim: "",
                  type: "text",
                },
                model: {
                  value: _vm.number,
                  callback: function ($$v) {
                    _vm.number = $$v
                  },
                  expression: "number",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message-input" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("message.writeYourMessage"),
              "show-attributes": false,
              "show-emoji": true,
              "preview-mode": false,
              "whatsapp-mode": false,
              "allowed-attributes": false,
              "max-character-count": 160,
            },
            model: {
              value: _vm.text,
              callback: function ($$v) {
                _vm.text = $$v
              },
              expression: "text",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-button",
        {
          staticClass: "sendSMSButton",
          attrs: { type: "primary", disabled: !_vm.formIsValid() },
          on: { click: _vm.sendSMS },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center gap-5",
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("send")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.sendSms")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }